import { FrontendToolContext } from './types'
import { getActiveAgentBus, type WorkspaceContextSnapshot } from './fdc3Bridge'

export interface AppCatalogEntry {
  name: string
  uniqueName: string
}

export interface UIStateSnapshot {
  currentPage: string
  sidePanelOpen: boolean
  activeSidePanelTab: string | null
  selectedAgent: string | null
  threadId: string | null
  availableApps: AppCatalogEntry[]
  /**
   * Live FDC3 interop context (Spec 010 §8). Present only when Ali is bound to a
   * Desktop Agent; absent off the bus so existing behaviour is unchanged. Treated
   * by the agent as untrusted DATA, never instructions (§10).
   */
  workspaceContext?: WorkspaceContextSnapshot
}

export function getUIState(context: FrontendToolContext): UIStateSnapshot {
  // Build compact app catalog from Redux state
  const reduxState = context.getState()
  const allApps: any[] = reduxState?.allAppsReducer?.allApps || []
  const availableApps: AppCatalogEntry[] = allApps.map((app: any) => ({
    name: app.name,
    uniqueName: app.uniqueName
  }))

  const snapshot: UIStateSnapshot = {
    currentPage: window.location.pathname,
    sidePanelOpen: !!context.chatbotContext.selectedMessage,
    activeSidePanelTab: context.chatbotContext.selectedMessage?.type || null,
    selectedAgent: context.chatbotContext.selectedAgent?.name || null,
    threadId: context.chatbotContext.currentChat?.id || null,
    availableApps
  }

  // Additive: project the workspace interop context when Ali is on the bus (§8.1).
  const workspaceContext = getActiveAgentBus()?.getSnapshot()
  if (workspaceContext) snapshot.workspaceContext = workspaceContext

  return snapshot
}
